import React, { ReactElement } from "react"
import { useBoolean } from "src/hooks/useBoolean"
import { ArrowForwardIos } from "@mui/icons-material"

import RocketIcon from "src/assets/icons/rocket.svg"
import { Box } from "@mui/material"
import { PoolName } from "src/constants"
import { PoolDataType, FarmBoostData } from "src/hooks/usePoolData"
import { formatBNToString, formatBoostedApr } from "src/utils"
import useXFerState from "src/pages/Stake/hooks/useXFerState"

import DepositModal from "src/pages/Stake/components/DepositModal"
import NftStakingModal from "./NftStakingModal"
import IncreaseBoostModal from "./IncreaseBoostModal"
import Text from "../Text"

interface Props {
  poolData: PoolDataType
  boostData?: FarmBoostData
}

export default function BoostedInfo({
  poolData,
  boostData,
}: Props): ReactElement {
  const [showModal, openModal, closeModal] = useBoolean(false)
  const { openedDepositModal, openedNftStakeModal } = useXFerState()
  const boostFactor = boostData?.boostFactor
    ? parseFloat(formatBNToString(boostData.boostFactor, 18))
    : 1
  const maxBoostFactor = boostData?.maxBoostFactor
    ? parseFloat(formatBNToString(boostData.maxBoostFactor, 18))
    : 1
  return (
    <Box
      mt={2}
      p={2}
      sx={{
        backgroundColor: "#000000",
        borderRadius: "10px",
      }}
    >
      <Text color="dim" size="micro">
        Current Boosted APR
      </Text>
      <Box mt="4px" gap="4px" display="flex" alignItems="center">
        <img src={RocketIcon} height={12} />
        <Text color="#00A68C">
          {formatBoostedApr(poolData.apr, poolData.ferroApr, boostFactor)}
        </Text>
      </Box>
      <Box
        mt={2}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          border: "1px solid #00A68C",
          padding: "12px",
          borderRadius: "10px",
          cursor: "pointer",
        }}
        onClick={openModal}
      >
        <Text size="small">
          Potentially earn MAX boosted APR{" "}
          {formatBoostedApr(poolData.apr, poolData.ferroApr, maxBoostFactor)}
        </Text>
        <ArrowForwardIos fontSize="small" />
      </Box>
      <IncreaseBoostModal
        open={showModal}
        onClose={closeModal}
        poolName={poolData.name as PoolName}
      />
      {openedDepositModal && (
        <DepositModal
          defaultSelectedPool={openedDepositModal.defaultSelectedPool}
        />
      )}
      {openedNftStakeModal && <NftStakingModal />}
    </Box>
  )
}
